import { useParams } from 'react-router';

import Header from '../Header';
import { RightSidebarWrapper } from '../RightSidebar/RightSidebarWrapper';
import CaseSummaryTab from '../icm/CaseSummaryTab';
import FinancialCaseTab from '../icm/FinancialCaseTab';
import GovernanceTab from '../icm/GovernanceTab';
import KeyFinancialDriversTab from '../icm/KeyFinancialDriversTab';

import FinancialOverviewTab from './FinancialOverviewTab';

import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger
} from '@/components/ui/tabs';

const InvestmentsDirectIdFinancials = () => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    throw new Error('Missing deal opportunity ID');
  }

  return (
    <>
      <Header />
      <RightSidebarWrapper>
        <div className="min-w-0 space-y-5 px-5 pt-5 pb-16.5 md:pl-14">
          <Tabs defaultValue="financial-overview">
            <TabsList className="h-auto! w-full justify-start overflow-x-auto overflow-y-hidden">
              <TabsTrigger value="financial-overview">
                Financial Overview
              </TabsTrigger>
              <TabsTrigger value="key-financial-drivers">
                Key Financial Drivers & Model Sensitivities
              </TabsTrigger>
              <TabsTrigger value="case-summary">Case Summary</TabsTrigger>
              <TabsTrigger value="financial-case">Financial Case</TabsTrigger>
              <TabsTrigger value="governance">
                Post Close Governance & Ownership Alignment
              </TabsTrigger>
            </TabsList>
            <TabsContent
              className="space-y-2.5"
              value="financial-overview"
            >
              <FinancialOverviewTab dealId={id} />
            </TabsContent>
            <TabsContent
              className="space-y-2.5"
              value="key-financial-drivers"
            >
              <KeyFinancialDriversTab dealId={id} />
            </TabsContent>
            <TabsContent
              className="space-y-2.5"
              value="case-summary"
            >
              <CaseSummaryTab dealId={id} />
            </TabsContent>
            <TabsContent
              className="space-y-2.5"
              value="financial-case"
            >
              <FinancialCaseTab dealId={id} />
            </TabsContent>
            <TabsContent
              className="space-y-2.5"
              value="governance"
            >
              <GovernanceTab dealId={id} />
            </TabsContent>
          </Tabs>
        </div>
      </RightSidebarWrapper>
    </>
  );
};

export default InvestmentsDirectIdFinancials;
